import { useCallback } from "react";

import BaseTableV3 from "components/BaseTableV3/BaseTableV3";
import { getNextQueryParams } from "components/helpers";
import RegionService from "services/Regions";
import {
  invalidateRegionsTableQuery,
  useRegionsTable,
} from "hooks/useRegionsTable";
import NewRegionModal from "./NewRegionModal";
import ACL_RELATIONSHIPS from "acl-relationships";
import withRoleCheck from "components/hocs/withRoleCheck";

const NewRegionModalWithRole = withRoleCheck(NewRegionModal, [
  ACL_RELATIONSHIPS.region.create,
]);

export const REGIONS_TABLE_CONSTANTS = {
  tableName: "regions",
  queryKey: "regions",
  className: "Region",
  exportTableName: null,
  header: "Regions",
  headerIcon: "map marker alternate",
};

const RegionsTableV3 = () => {
  const { filters, columns } = useRegionsTable({
    tableName: REGIONS_TABLE_CONSTANTS.tableName,
  });

  const fetchRegions = useCallback(
    async queryParams => {
      try {
        const nextQueryParams = getNextQueryParams(queryParams, columns);

        const response = await RegionService.getRegionsTable(nextQueryParams);
        return response;
      } catch (error) {
        console.error("Error fetching regions:", error);
        throw error;
      }
    },
    [columns]
  );

  return (
    <BaseTableV3
      columns={columns}
      filters={filters}
      headerIcon={REGIONS_TABLE_CONSTANTS.headerIcon}
      header={REGIONS_TABLE_CONSTANTS.header}
      tableName={REGIONS_TABLE_CONSTANTS.tableName}
      queryKey={REGIONS_TABLE_CONSTANTS.queryKey}
      className={REGIONS_TABLE_CONSTANTS.className}
      exportTableName={REGIONS_TABLE_CONSTANTS.exportTableName}
      fetchData={fetchRegions}
      createButton={
        <NewRegionModalWithRole onSuccess={invalidateRegionsTableQuery} />
      }
      enableSearch={false}
      enableSettings
      invalidateData={invalidateRegionsTableQuery}
    />
  );
};

export default RegionsTableV3;
